var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.5C4.93913 2.5 3.92172 2.92143 3.17157 3.67157C2.42143 4.42172 2 5.43913 2 6.5V26.5C2 27.5609 2.42143 28.5783 3.17157 29.3284C3.92172 30.0786 4.93913 30.5 6 30.5H26C27.0609 30.5 28.0783 30.0786 28.8284 29.3284C29.5786 28.5783 30 27.5609 30 26.5V6.5C30 5.43913 29.5786 4.42172 28.8284 3.67157C28.0783 2.92143 27.0609 2.5 26 2.5H6ZM8.204 11.094C8.83787 11.094 9.44577 10.8422 9.89398 10.394C10.3422 9.94577 10.594 9.33787 10.594 8.704C10.594 8.07013 10.3422 7.46223 9.89398 7.01401C9.44577 6.5658 8.83787 6.314 8.204 6.314C7.57013 6.314 6.96223 6.5658 6.51401 7.01401C6.0658 7.46223 5.814 8.07013 5.814 8.704C5.814 9.33787 6.0658 9.94577 6.51401 10.394C6.96223 10.8422 7.57013 11.094 8.204 11.094ZM10.204 26.126V12.968H6.204V26.126H10.204ZM12.86 12.968H16.86V14.73C17.45 13.806 18.746 12.562 21.156 12.562C24.032 12.562 25.594 14.468 25.594 18.094C25.594 18.268 25.61 19.062 25.61 19.062V26.124H21.61V19.064C21.61 18.094 21.406 16.188 19.25 16.188C17.092 16.188 16.91 18.584 16.86 20.152V26.124H12.86V12.968Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer_linkedin.300ddb13c4a50fecc419f6086c059028.svg";
export { ForwardRef as ReactComponent };